import React, { Component } from 'react';
import '../../repeatFooter.scss';

class DailyView extends Component {
    constructor() {
        super();
        this.state = {
            interval: 1
        };
        this.updateOccurances = this.updateOccurances.bind( this );
    }

    componentWillMount() {
        if ( typeof this.props.data !== 'undefined' && Object.keys( this.props.data ).hasItems() && Object.keys( this.props.data.repeatOptions ).hasItems() ) {
            this.setState( { interval: this.props.data.repeatOptions.interval } );
        } else {
            this.props.callback( { type: 'DAILY', payload: { interval: this.state.interval } } );
        }
    }

    updateOccurances( value ) {
        if ( Number( value ) > 9999 || Number( value ) < 1 || this.props.disabled ) {
            return;
        }
        this.setState( { interval: value } );
        this.props.callback( { type: 'DAILY', payload: { interval: value } } );
    }

    render() {
        return (
            <React.Fragment>
                Every:
                <input
                    type="number"
                    className="texteditor-input"
                    min="0"
                    max="99"
                    defaultValue={ 1 }
                    value={ this.state.interval }
                    disabled={ this.props.disabled }
                    onChange={ e => this.updateOccurances( e.target.value ) } /> <span>occurrence(s)</span>
            </React.Fragment>
        );
    }
}

export default DailyView;
